// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__gGmQy","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1UYFM"};